const GLightbox = require('glightbox');
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import '../views/blocks/brands-slider/brands-slider.js';
import '../views/blocks/slider-square/slider-square.js';
import '../views/blocks/slider-catalogs/slider-catalogs.js';
import '../views/blocks/header-locations/header-locations.js';
import './sticky';

window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(collapse);

Alpine.start();

/**
 * Initialize lightbox
 */
const lightbox = GLightbox({
    selector: '.lightbox-gallery',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});
